import type { TicketingTeamWorkloadPayload } from '../pages/TicketingAnalytics/types';

export const TICKETING_TEAM_WORKLOAD_MOCK: TicketingTeamWorkloadPayload = {
	overview: [
		{
			key: 'active_agents',
			title: 'Active Agents',
			value: 5,
			unit: 'agents',
			trend: null,
			description: 'of 8 Sustain Team members within configured working hours now',
		},
		{
			key: 'average_tickets_per_agent',
			title: 'Average Tickets per Agent',
			value: 102.3,
			unit: 'tickets',
			trend: null,
			description: '818 assigned across 8 agents',
		},
		{
			key: 'busiest_agent',
			title: 'Busiest Agent',
			value: 'J. Martinez',
			unit: null,
			trend: { value: 39, unit: 'percent', direction: 'up', impact: 'negative' },
			description: '142 assigned • 39% above average',
		},
		{
			key: 'unassigned_tickets',
			title: 'Unassigned Tickets',
			value: 9,
			unit: 'tickets',
			trend: null,
			description: 'Average queue age: 5.2 hrs',
		},
	],
	ticketDistribution: {
		title: 'Ticket Distribution',
		series: [
			{ teamMember: 'J. Martinez', assignedTickets: 142, openTickets: 38, closedTickets: 104 },
			{ teamMember: 'A. Patel', assignedTickets: 128, openTickets: 31, closedTickets: 97 },
			{ teamMember: 'S. Thompson', assignedTickets: 117, openTickets: 28, closedTickets: 89 },
			{ teamMember: 'R. Chen', assignedTickets: 104, openTickets: 25, closedTickets: 79 },
			{ teamMember: 'K. Williams', assignedTickets: 96, openTickets: 22, closedTickets: 74 },
			{ teamMember: 'D. Okafor', assignedTickets: 88, openTickets: 19, closedTickets: 69 },
			{ teamMember: 'M. Reyes', assignedTickets: 79, openTickets: 17, closedTickets: 62 },
			{ teamMember: 'T. Nguyen', assignedTickets: 64, openTickets: 13, closedTickets: 51 },
		],
	},
	ticketsByTeamMember: [
		{
			teamMember: 'J. Martinez',
			assignedTickets: 142,
			openTickets: 38,
			closedTickets: 104,
			averageResolutionTime: { value: 1, unit: 'days' },
			averageTimeInProgress: { value: 13.2, unit: 'hours' },
			averageTimeEscalatedToIT: { value: 2.4, unit: 'days' },
			averageTimeEscalatedToTMV: { value: 4, unit: 'days' },
			averageTimeSubmittedToADO: { value: 11.2, unit: 'days' },
			averageTimeWaitingOnUser: { value: 2, unit: 'days' },
			resolutionRate: 73.2,
		},
		{
			teamMember: 'A. Patel',
			assignedTickets: 128,
			openTickets: 31,
			closedTickets: 97,
			averageResolutionTime: { value: 22.3, unit: 'hours' },
			averageTimeInProgress: { value: 11.8, unit: 'hours' },
			averageTimeEscalatedToIT: { value: 2.2, unit: 'days' },
			averageTimeEscalatedToTMV: { value: 3.7, unit: 'days' },
			averageTimeSubmittedToADO: { value: 10, unit: 'days' },
			averageTimeWaitingOnUser: { value: 1.8, unit: 'days' },
			resolutionRate: 75.8,
		},
		{
			teamMember: 'S. Thompson',
			assignedTickets: 117,
			openTickets: 28,
			closedTickets: 89,
			averageResolutionTime: { value: 1.1, unit: 'days' },
			averageTimeInProgress: { value: 14.6, unit: 'hours' },
			averageTimeEscalatedToIT: { value: 2.6, unit: 'days' },
			averageTimeEscalatedToTMV: { value: 4.2, unit: 'days' },
			averageTimeSubmittedToADO: { value: 11.9, unit: 'days' },
			averageTimeWaitingOnUser: { value: 2.2, unit: 'days' },
			resolutionRate: 76.1,
		},
		{
			teamMember: 'R. Chen',
			assignedTickets: 104,
			openTickets: 25,
			closedTickets: 79,
			averageResolutionTime: { value: 23.4, unit: 'hours' },
			averageTimeInProgress: { value: 12.1, unit: 'hours' },
			averageTimeEscalatedToIT: { value: 2.3, unit: 'days' },
			averageTimeEscalatedToTMV: { value: 3.8, unit: 'days' },
			averageTimeSubmittedToADO: { value: 10.4, unit: 'days' },
			averageTimeWaitingOnUser: { value: 2, unit: 'days' },
			resolutionRate: 76.0,
		},
		{
			teamMember: 'K. Williams',
			assignedTickets: 96,
			openTickets: 22,
			closedTickets: 74,
			averageResolutionTime: { value: 1.2, unit: 'days' },
			averageTimeInProgress: { value: 15.9, unit: 'hours' },
			averageTimeEscalatedToIT: { value: 2.8, unit: 'days' },
			averageTimeEscalatedToTMV: { value: 4.6, unit: 'days' },
			averageTimeSubmittedToADO: { value: 12.7, unit: 'days' },
			averageTimeWaitingOnUser: { value: 2.4, unit: 'days' },
			resolutionRate: 77.1,
		},
		{
			teamMember: 'D. Okafor',
			assignedTickets: 88,
			openTickets: 19,
			closedTickets: 69,
			averageResolutionTime: { value: 1, unit: 'days' },
			averageTimeInProgress: { value: 13.5, unit: 'hours' },
			averageTimeEscalatedToIT: { value: 2.5, unit: 'days' },
			averageTimeEscalatedToTMV: { value: 4, unit: 'days' },
			averageTimeSubmittedToADO: { value: 10.9, unit: 'days' },
			averageTimeWaitingOnUser: { value: 2.1, unit: 'days' },
			resolutionRate: 78.4,
		},
		{
			teamMember: 'M. Reyes',
			assignedTickets: 79,
			openTickets: 17,
			closedTickets: 62,
			averageResolutionTime: { value: 1.2, unit: 'days' },
			averageTimeInProgress: { value: 16.8, unit: 'hours' },
			averageTimeEscalatedToIT: { value: 3, unit: 'days' },
			averageTimeEscalatedToTMV: { value: 4.8, unit: 'days' },
			averageTimeSubmittedToADO: { value: 13.4, unit: 'days' },
			averageTimeWaitingOnUser: { value: 2.5, unit: 'days' },
			resolutionRate: 78.5,
		},
		{
			teamMember: 'T. Nguyen',
			assignedTickets: 64,
			openTickets: 13,
			closedTickets: 51,
			averageResolutionTime: { value: 1.3, unit: 'days' },
			averageTimeInProgress: { value: 18.2, unit: 'hours' },
			averageTimeEscalatedToIT: { value: 3.2, unit: 'days' },
			averageTimeEscalatedToTMV: { value: 5.2, unit: 'days' },
			averageTimeSubmittedToADO: { value: 14.1, unit: 'days' },
			averageTimeWaitingOnUser: { value: 2.8, unit: 'days' },
			resolutionRate: 79.7,
		},
	],
};

